/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template is added per tube, not to the shared master mix.`)
};

const es_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El molde se añade por tubo, no al master mix compartido.`)
};

const de_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Template-DNA wird pro Röhrchen zugegeben, nicht in den gemeinsamen Mastermix.`)
};

const nl_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template wordt per buisje toegevoegd, niet aan de gedeelde mastermix.`)
};

const fr_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La matrice est ajoutée par tube, pas dans le mix maître partagé.`)
};

const it_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il template va aggiunto per provetta, non nel master mix condiviso.`)
};

const pt_br2_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O molde é adicionado por tubo, não ao master mix compartilhado.`)
};

const pt_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O molde é adicionado por tubo, não à master mix partilhada.`)
};

const ja_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレートは共有のマスターミックスではなく、チューブごとに加えます。`)
};

const zh_pcr_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板需单独加入每管，而非加入共用的混合液中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_ex2", locale)
	if (locale === "en") return en_pcr_ex2(inputs)
	if (locale === "es") return es_pcr_ex2(inputs)
	if (locale === "de") return de_pcr_ex2(inputs)
	if (locale === "nl") return nl_pcr_ex2(inputs)
	if (locale === "fr") return fr_pcr_ex2(inputs)
	if (locale === "it") return it_pcr_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_ex2(inputs)
	if (locale === "pt") return pt_pcr_ex2(inputs)
	if (locale === "ja") return ja_pcr_ex2(inputs)
	return zh_pcr_ex2(inputs)
};